module.exports = __webpack_public_path__ + "media/images/flag/gb-d791a348e77cda116232437b62efe235.jpg";